import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { colors } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { SportsIcon } from '@core/Areas/KambiSports/Components/Common/SportsIcon'
import { LegStatusIcon } from '../LegStatusIcon'

export const LegsProgressStatus: React.FC<{
  outcomes: KambiHistoryCoupon['outcomes']
  events: KambiHistoryCoupon['events']
}> = ({ outcomes, events }) => (
  <div style={{ paddingTop: '0.2rem' }}>
    <Flex gap='0.4rem' alignItems='center'>
      {outcomes.map(outcome => {
        if (outcome.status === 'WON' || outcome.status === 'LOST') {
          return <LegStatusIcon key={outcome.outcomeId} status={outcome.status} />
        }

        const event = events.find(e => e.eventId === outcome.eventId)
        const sportName = event?.sport

        return (
          <SportsIcon
            key={outcome.outcomeId}
            sport={sportName}
            size='1.6rem'
            color={colors.neutral[700]}
          />
        )
      })}
    </Flex>
  </div>
)
